import sortBy from 'lodash/sortBy';
import format from 'date-fns/format';
import min from 'lodash/min';
import max from 'lodash/max';
import { addDays } from '../../../../../../../src/utils/date';

import { NUMBER_SCALE } from '../../../../../../../src/constants';

const AXIS_DATE_FORMAT = 'D MMM';

// `data` may only contain < NUM_DAYS and these must be displayed at the right
// of the xAxis. Also the scale must ignore weekends. So we use an ordinal scale
// with the x axis as integers rather than a time-based scale
function getChartData(data, numDays) {
  const sorted = sortBy(data, item => item.date)
    .slice(0, numDays);

  return sorted.map((item) => {
    const date = new Date(item.date);
    return {
      x: date,
      y: item.price.value,
      date: item.date,
      price: item.price,
    };
  });
}

function formatDateLabel(date,langCode) {
  const dateFormatOptions = {
   month: 'short', day: 'numeric'
  }  
  return new Intl.DateTimeFormat(langCode, dateFormatOptions).format(date);
}

function getYAxisDomain(data) {
  return expandedDomain(data.map(row => row.price.value));
}

function getYAxisDivisorIndex(domain) {
  const absoluteLargest = Math.max(
    Math.abs(domain[0]),
    Math.abs(domain[1])
  );

  let divisorIndex = 0;
  while (absoluteLargest / Math.pow(1000, divisorIndex + 1) >= 1) {
    divisorIndex += 1;
  }

  return divisorIndex;
}

function getYAxisTitle(divisorIndex, currency) {
  if (!divisorIndex || !currency) {
    return undefined;
  }

  return `(${NUMBER_SCALE[divisorIndex]} ${currency})`;
}

function getYTickFormatter(divisorIndex) {
  return (y, i, ticks) => {
    const tick = y / Math.pow(1000, divisorIndex);
    return Array.isArray(ticks) && !!ticks.filter(x => x % 1 !== 0).length
      ? tick.toFixed(2)
      : tick;
  };
}

function getXSmallTicks(dates) {
  if (!dates || dates.length === 0) {
    return [];
  }
  let minDate = min(dates);
  let maxDate = max(dates);

  const diff = maxDate.valueOf() - minDate.valueOf();

  minDate = new Date(minDate.valueOf() - diff * 0.1);
  maxDate = new Date(maxDate.valueOf() + diff * 0.1);

  minDate = new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate());
  maxDate = new Date(maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate());

  let currentDate = minDate;

  const result = [];

  while (currentDate < maxDate) {
    result.push(currentDate);

    currentDate = addDays(currentDate, 1);
  }

  return result;
}

function expandedDomain(data) {
  if (!data || !data.length) {
    return [0, 0];
  }

  let minValue = min(data);
  let maxValue = max(data);
  let span = 0;
  let extendBy = 0;
  if(minValue === maxValue){
    minValue = minValue*.8;
    maxValue = maxValue * 1.2;
  }
  else {
    span = maxValue - minValue;
    extendBy = Math.max(1, Math.pow(10, Math.floor(Math.log10(span))));
    if (minValue % extendBy !== 0) {
      minValue = Math.ceil(minValue / extendBy) * extendBy - extendBy;
    }

    if (maxValue % extendBy !== 0) {
      maxValue = Math.floor(maxValue / extendBy) * extendBy + extendBy;
    }

  }
  return [minValue, maxValue];
}

export {
  getChartData,
  formatDateLabel,
  getXSmallTicks,
  getYAxisDomain,
  getYAxisDivisorIndex,
  getYAxisTitle,
  getYTickFormatter,
  expandedDomain,
};
